import React from 'react';
import { useTopicTags } from './topic-tags';

export const PrimaryTopicTag: React.FC<{ id: string }> = ({ id }) => {
  const topicTags = useTopicTags();
  const topicTag = topicTags.get(id);
  return topicTag?.fields.name ? <>{topicTag.fields.name['en-US']}</> : null;
};
